import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { pageview } from '#app/utils/google-analytics.client.ts'

export function GoogleAnalytics() {
  const googleAnalyticsTrackingId = ENV.GOOGLE_ANALYTICS_TRACKING_ID

  const includeGoogleAnalytics =
    ENV.MODE === 'production' && googleAnalyticsTrackingId

  const location = useLocation()

  useEffect(() => {
    if (includeGoogleAnalytics) {
      pageview(location.pathname, googleAnalyticsTrackingId)
    }
  }, [location, includeGoogleAnalytics, googleAnalyticsTrackingId])

  if (!includeGoogleAnalytics) {
    return null
  }

  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsTrackingId}`}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());

  gtag("config", "${googleAnalyticsTrackingId}");
          `,
        }}
      ></script>
    </>
  )
}
